module.exports = __webpack_public_path__ + "static/media/carnehill.f499ed54.png";